export default function VentilationGrid() {
  const products = [
    {
      name: 'Zehnder ComfoAir Q600',
      category: 'VMC double flux haut rendement',
      capacity: 'Débit 600 m³/h',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Zehnder%20ComfoAir%20Q600%20heat%20recovery%20ventilation%20unit%20in%20white%20compact%20housing%20with%20digital%20control%20panel%2C%20high-end%20Swiss%20VMC%20system%20with%20advanced%20filtration%20and%20heat%20exchanger%2C%20professional%20HVAC%20equipment%20with%20modern%20minimalist%20design%2C%20technical%20product%20photography%20showing%20front%20interface&width=800&height=600&seq=zehnder-q600&orientation=portrait',
      features: ['Récupération chaleur 95%', 'Filtres F7 + G4 inclus', 'Débit variable intelligent', 'Niveau sonore 25 dB(A)', 'Application ComfoControl'],
      specs: { brand: 'Zehnder', efficiency: 'A+', warranty: '5 ans' }
    },
    {
      name: 'Helios KWL EC 370',
      category: 'VMC double flux compacte',
      capacity: 'Débit 370 m³/h',
      image: 'https://readdy.ai/api/search-image?query=Compact%20Helios%20KWL%20EC%20370%20ventilation%20system%20in%20sleek%20white%20cabinet%20with%20integrated%20controls%2C%20energy-efficient%20German%20VMC%20unit%20with%20heat%20recovery%20technology%2C%20professional%20residential%20ventilation%20equipment%20with%20space-saving%20design%2C%20product%20photography%20showing%20compact%20dimensions&width=800&height=600&seq=helios-kwl&orientation=portrait',
      features: ['Échangeur enthalpique', 'Moteurs EC basse consommation', 'Bypass été automatique', 'Filtration pollen F7', 'Garantie 5 ans pièces'],
      specs: { brand: 'Helios', efficiency: 'A', warranty: '5 ans' }
    },
    {
      name: 'Vallox 145 MV',
      category: 'VMC double flux premium',
      capacity: 'Débit 450 m³/h',
      image: 'https://readdy.ai/api/search-image?query=Sophisticated%20Vallox%20145%20MV%20ventilation%20unit%20in%20elegant%20white%20housing%20with%20touchscreen%20display%2C%20premium%20Finnish%20heat%20recovery%20system%20with%20advanced%20climate%20control%2C%20high-end%20residential%20VMC%20equipment%20with%20contemporary%20design%2C%20professional%20product%20photography%20showing%20control%20interface&width=800&height=600&seq=vallox-145&orientation=portrait',
      features: ['Récupération jusqu\'à 92%', 'Écran tactile couleur', 'Capteurs CO2 et humidité', 'Mode nuit silencieux', 'Connexion WiFi intégrée'],
      specs: { brand: 'Vallox', efficiency: 'A+', warranty: '5 ans' }
    },
    {
      name: 'Paul Focus 200',
      category: 'VMC décentralisée',
      capacity: 'Débit 60 m³/h par unité',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Paul%20Focus%20200%20decentralized%20ventilation%20unit%20in%20circular%20white%20design%20with%20ceramic%20heat%20exchanger%2C%20compact%20German%20room%20ventilation%20system%20with%20reversible%20airflow%2C%20innovative%20single-room%20VMC%20solution%20with%20minimalist%20styling%2C%20technical%20product%20photography%20showing%20cylindrical%20form&width=800&height=600&seq=paul-focus&orientation=portrait',
      features: ['Installation sans gaines', 'Échangeur céramique', 'Fonctionnement alterné', 'Idéal rénovation', 'Télécommande infrarouge'],
      specs: { brand: 'Paul', efficiency: 'B+', warranty: '3 ans' }
    },
    {
      name: 'Dantherm HCV 400',
      category: 'VMC double flux tertiaire',
      capacity: 'Débit 1200 m³/h',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20Dantherm%20HCV%20400%20commercial%20ventilation%20system%20in%20robust%20gray%20metal%20housing%20with%20large%20heat%20exchanger%2C%20professional%20high-capacity%20VMC%20unit%20for%20commercial%20buildings%2C%20heavy-duty%20HVAC%20equipment%20with%20modular%20construction%2C%20technical%20photography%20showing%20industrial-grade%20design&width=800&height=600&seq=dantherm-hcv&orientation=portrait',
      features: ['Haute capacité tertiaire', 'Échangeur à plaques', 'Filtres F9 haute efficacité', 'Régulation BMS compatible', 'Construction robuste'],
      specs: { brand: 'Dantherm', efficiency: 'A', warranty: '3 ans' }
    },
    {
      name: 'Réseau Gaines Aldes',
      category: 'Kit distribution d\'air',
      capacity: 'Maison 150 m²',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Aldes%20ventilation%20ductwork%20system%20with%20white%20flexible%20ducts%20and%20distribution%20boxes%2C%20complete%20air%20distribution%20network%20with%20diffusers%20and%20grilles%2C%20organized%20HVAC%20duct%20installation%20components%2C%20technical%20product%20photography%20showing%20ductwork%20materials&width=800&height=600&seq=aldes-ducts&orientation=portrait',
      features: ['Gaines semi-rigides Ø75-160mm', 'Bouches extraction hygroréglables', 'Diffuseurs air neuf design', 'Plénum de distribution', 'Accessoires de fixation'],
      specs: { brand: 'Aldes', efficiency: 'A', warranty: '10 ans' }
    },
    {
      name: 'Filtres HEPA H13',
      category: 'Filtration haute performance',
      capacity: 'Pack annuel',
      image: 'https://readdy.ai/api/search-image?query=High-efficiency%20HEPA%20H13%20air%20filters%20in%20white%20pleated%20design%20with%20sturdy%20frame%2C%20premium%20medical-grade%20filtration%20media%20for%20ventilation%20systems%2C%20professional%20air%20quality%20filters%20with%20dense%20fiber%20construction%2C%20product%20photography%20showing%20filter%20details%20and%20construction&width=800&height=600&seq=hepa-filters&orientation=portrait',
      features: ['Filtration 99.95% particules', 'Capture virus et bactéries', 'Filtre pollen et allergènes', 'Durée de vie 12 mois', 'Compatible Zehnder/Helios'],
      specs: { brand: 'Multi-marques', efficiency: 'H13', warranty: '1 an' }
    },
    {
      name: 'Puits Canadien Rehau',
      category: 'Échangeur géothermique',
      capacity: '80m de tubes Ø200mm',
      image: 'https://readdy.ai/api/search-image?query=Rehau%20geothermal%20earth%20tubes%20system%20with%20blue%20corrugated%20pipes%20and%20distribution%20manifold%2C%20professional%20ground%20heat%20exchanger%20for%20ventilation%20pre-conditioning%2C%20underground%20HVAC%20system%20components%20with%20durable%20construction%2C%20technical%20product%20photography%20showing%20pipe%20system&width=800&height=600&seq=rehau-earth&orientation=portrait',
      features: ['Tubes PE-Xa Ø200mm', 'Collecteur de distribution', 'Condensats intégrés', 'Préchauffage/rafraîchissement', 'Économies énergétiques 30%'],
      specs: { brand: 'Rehau', efficiency: 'A+', warranty: '10 ans' }
    },
    {
      name: 'Régulation Siemens Synco',
      category: 'Système de contrôle intelligent',
      capacity: 'Gestion multi-zones',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20Siemens%20Synco%20building%20automation%20controller%20with%20digital%20display%20and%20control%20buttons%2C%20professional%20HVAC%20management%20system%20with%20intelligent%20programming%2C%20industrial-grade%20climate%20control%20equipment%20with%20modern%20interface%2C%20technical%20product%20photography%20showing%20control%20panel&width=800&height=600&seq=siemens-synco&orientation=portrait',
      features: ['Régulation température/humidité', 'Programmation horaire', 'Capteurs CO2 intégrés', 'Interface web', 'Optimisation consommation'],
      specs: { brand: 'Siemens', efficiency: 'A', warranty: '5 ans' }
    }
  ];

  return (
    <section id="produits" className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Nos Systèmes VMC</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Ventilation Mécanique Contrôlée Premium
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400">
            Solutions complètes de ventilation double flux avec récupération de chaleur. Air sain et économies d'énergie garanties.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden hover:border-orange-500/40 transition-all">
              <div className="relative w-full h-80 bg-gray-700">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {product.specs.brand}
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <p className="text-sm text-orange-400 font-semibold mb-1">{product.category}</p>
                  <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-sm text-gray-400">{product.capacity}</p>
                </div>
                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-orange-400 mt-1 mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="border-t border-gray-700 pt-4 mb-6">
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-gray-500">Efficacité</p>
                      <p className="font-semibold text-gray-200">{product.specs.efficiency}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Garantie</p>
                      <p className="font-semibold text-gray-200">{product.specs.warranty}</p>
                    </div>
                  </div>
                </div>
                <a href="#contact" className="block w-full text-center rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer">
                  Demander un devis
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gray-800 rounded-2xl p-8 border border-orange-500/20">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg flex-shrink-0">
              <i className="ri-windy-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Installation et mise en service complète</h3>
              <p className="text-gray-400 leading-relaxed mb-4">
                Nos techniciens certifiés assurent l'installation de votre VMC double flux avec pose du réseau de gaines, raccordements électriques, réglages des débits et équilibrage du système. Mise en service avec formation à l'utilisation.
              </p>
              <p className="text-gray-400 leading-relaxed">
                <strong className="text-white">Avantages VMC double flux:</strong> Récupération de 90% de la chaleur, renouvellement d'air constant, filtration des pollens et allergènes, économies de chauffage jusqu'à 30%, confort thermique optimal toute l'année.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
